import { Validators } from "@angular/forms";
import { ValidationErrorKey } from "../../validators/general-validation.";
import { ControlType } from "../base";
import {
  FormFieldInput,
  HtmlInputMode,
  HtmlInputType,
  InputAutoCompleteAttribute,
  InputFormFieldInit,
} from "./base";

// Custom validator for 6-digit code
export const codeValidator = Validators.pattern(/^\d{6}$/);

export class FormFieldInputCode extends FormFieldInput {
  public override controlType = ControlType.CODE;

  constructor(init: InputFormFieldInit<FormFieldInputCode>) {
    super({
      ...init,
      label: init.label ?? $localize`E-Mail Code`,
      placeholder: init.placeholder ?? "123456",
    });

    this.inputType = HtmlInputType.TEXT; // Using text to avoid browser styling issues with number inputs
    this.validators = [
      codeValidator, // Custom validator for 6 digits
      ...(init.validators ?? []),
    ];
    this.autoComplete = InputAutoCompleteAttribute.OFF; // No autocomplete for code inputs
    this.inputMode = HtmlInputMode.NUMERIC; // Numeric keyboard on mobile devices

    // Add error messages for validation
    super.addErrorMessages({
      [ValidationErrorKey.PATTERN]: $localize`Der Code muss genau 6 Ziffern enthalten.`,
    });
  }
}
